// 9fbef606107a605d69c0edbcd8029e5d
import React, { useState } from 'react';
import { getIconPath } from '@tcp/core/src/utils';
import Image from '@tcp/core/src/components/common/atoms/Image';
import {
  L1NavItemContainer,
  L1NavItemHeader,
  L1NavItemContent,
} from '@tcp/web/src/components/features/content/Navigation/molecules/GroupedL1NavItems/GroupedL1NavItems.style';

const GroupedL1NavItems = ({ groupName, defaultOpen = false, children }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const onToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <L1NavItemContainer>
      <L1NavItemHeader onClick={onToggle}>
        {groupName}
        {isOpen ? (
          <Image src={getIconPath('minus-circle')} className={`accordion-toggle-minus`} alt="" />
        ) : (
          <Image src={getIconPath('plus-circle')} className={`accordion-toggle-plus`} alt="" />
        )}
      </L1NavItemHeader>
      {isOpen && <L1NavItemContent>{children}</L1NavItemContent>}
    </L1NavItemContainer>
  );
};

export default GroupedL1NavItems;
